import { Result, Tag, Upload, UploadProps, theme } from 'antd';
import { FC } from 'react';
import { CheckCircleFill, CloudUpload } from 'react-bootstrap-icons';

interface Props {
  isFileUploading: boolean;
  showResultSuccess: boolean;
  uploaderProps: UploadProps;
}

export const SitesUploadArchiveView: FC<Props> = ({
  isFileUploading,
  showResultSuccess,
  uploaderProps
}) => {
  const { token: { colorSuccess } } = theme.useToken();

  return (
    <>
      {
        showResultSuccess
          ? (
            <Result status="success" icon={ <CheckCircleFill color={ colorSuccess } size={ 72 }/> }/>
          )
          : (
            <Upload.Dragger { ...uploaderProps } disabled={ isFileUploading }>
              <p className="ant-upload-drag-icon">
                <CloudUpload size={ 30 }/>
              </p>
              <p className="ant-upload-text">Натисніть або перетягніть файл у цю область, щоб завантажити</p>
              <p className="ant-upload-hint">
                Можна завантажити один <Tag>.zip</Tag> архів розміром до <Tag>1 ГБ</Tag>
              </p>
            </Upload.Dragger>
          )
      }
    </>
  );
};
